import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { countryDetail, countryStore, countryEdit, currencyResource } from '../request';
import moment from 'moment';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    isEdit: {
      type: [Boolean, Number, String],
      default: false,
      required: true
    }
  },
  data() {
    return {
      addForm: {
        currencyId: undefined,
        name: '',
        language: '',
        chronaxie: '24时',
        showValue: '2023-01-01 13:00:00',
        dateFormat: ''
      },
      currencyList: [],
      languageList: [{
        name: '简体中文',
        key: 'zh'
      }, {
        name: '繁體中文',
        key: 'cht'
      }, {
        name: 'English',
        key: 'en'
      }, {
        name: 'español',
        key: 'spa'
      }, {
        name: 'Français',
        key: 'fra'
      }
      // {name: 'Русский язык', key: 'ru'}
      ],
      saveLoading: false,
      isPass: true
    };
  },
  watch: {
    visible(newV) {
      if (newV && this.$props.isEdit) {
        this.getDetail();
      }
    }
  },
  created() {
    currencyResource({}).then(res => {
      this.currencyList = res;
    });
  },
  computed: {
    ADD_RULES() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('国家名称'),
          trigger: 'change'
        }, {
          message: this.$t('请输入') + '2-15' + this.$t('字符'),
          max: 15,
          min: 2
        }],
        currencyId: [{
          required: true,
          message: this.$t('请选择') + this.$t('货币名称'),
          trigger: 'change'
        }],
        language: [{
          required: true,
          message: this.$t('请选择') + this.$t('语言'),
          trigger: 'change'
        }],
        chronaxie: [{
          required: true,
          message: this.$t('请选择') + this.$t('时值'),
          trigger: 'change'
        }],
        dateFormat: [{
          required: true,
          validator: this.validDateFormat,
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    validDateFormat(rule, value, callback) {
      if (value) {
        // const reg = /^([YymdM]{1,4}[-/]{1}){2}[YymdM]{1,4}$/;
        const reg = /^.*((([Y]{1})|([ymd]{1})|([n]{1})|([M]{1}))[-/]{1}){2}(([Y]{1})|([ymd]{1})|([n]{1})|([M]{1}))$/;
        if (!reg.test(value)) {
          this.isPass = false;
          callback(new Error(this.$t('输入内容未能成功匹配，请重新输入')));
        } else {
          let length1 = value.split('-');
          let length2 = value.split('/');
          if (length1.length != 3 && length2.length != 3) {
            this.isPass = false;
            callback(new Error(this.$t('输入内容未能成功匹配，请重新输入')));
          } else if (!value.includes('Y') && !value.includes('y') || !value.includes('m') && !value.includes('n') && !value.includes('M') || !value.includes('d')) {
            this.isPass = false;
            callback(new Error(this.$t('输入内容未能成功匹配，请重新输入')));
          } else {
            this.isPass = true;
            callback();
          }
        }
      } else {
        this.isPass = false;
        callback(new Error(this.$t('请输入') + this.$t('日期格式')));
      }
    },
    closeAddVisible(e) {
      this.$emit('cancel', e);
      this.resetForm();
    },
    resetForm() {
      this.addForm.currencyId = undefined;
      this.addForm.name = '';
      this.addForm.language = '';
      this.addForm.chronaxie = '24时';
      this.addForm.showValue = '2023-01-01 13:00:00';
      this.addForm.dateFormat = '';
      this.$refs.addFormRef.resetFields();
    },
    async getDetail() {
      const res = await countryDetail({
        id: this.$props.isEdit
      });
      Object.assign(this.addForm, res);
      this.addForm.showValue = '2023-01-01 13:00:00';
      this.showDateFormat(this.addForm.dateFormat, this.addForm.showValue, this.addForm.chronaxie == '12时' ? 'a' : '');
    },
    changeDateFormat() {
      setTimeout(() => {
        if (this.isPass && this.addForm.dateFormat) {
          this.showDateFormat(this.addForm.dateFormat, '2023-01-01 13:00:00', this.addForm.chronaxie == '12时' ? 'a' : '');
        } else {
          this.addForm.showValue = '2023-01-01 13:00:00';
          this.showDateFormat('Y-m-d', this.addForm.showValue, this.addForm.chronaxie == '12时' ? 'a' : '');
        }
      }, 100);
    },
    showDateFormat(value, date, a) {
      let _separator = value.includes('-') ? '-' : '/';
      let newValue = value.split(_separator);
      let _format = '';
      _format = newValue.map(item => {
        if (item.includes('Y')) {
          item = item.replace('Y', 'YYYY');
        } else if (item.includes('y')) {
          item = item.replace('y', 'YY');
        } else if (item.includes('m')) {
          item = item.replace('m', 'MM');
        } else if (item.includes('M')) {
          item = item.replace('M', 'MMM');
        } else if (item.includes('n')) {
          item = item.replace('n', 'M');
        } else if (item.includes('d')) {
          item = item.replace('d', 'DD');
        }
        return item;
      }).join(_separator);
      // let _format = value
      //   .replaceAll('Y', 'YYYY')
      //   .replaceAll('y', 'YY')
      //   .replaceAll('m', 'MM')
      //   .replaceAll('M', 'MMM')
      //   .replaceAll('n', 'M')
      //   .replaceAll('d', 'DD');
      if (a) {
        this.addForm.showValue = moment(date).format(_format + ' hh:mm:ss' + ' ' + a);
      } else {
        this.addForm.showValue = moment(date).format(_format + ' HH:mm:ss');
      }
    },
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          // this.saveLoading = true;
          if (this.$props.isEdit) {
            await countryEdit(this.addForm);
          } else {
            await countryStore(this.addForm);
          }
          // this.saveLoading = false;
          this.$emit('save');
          this.closeAddVisible();
        }
      });
    }
  }
};